import { useEffect } from "react"
import { useAppToast } from "@ui-seeker/app"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS } from "@constants"
import {
    filtersValue,
    tableFiltersValue,
    isLoadingFilters,
    isLoadingTable,
    isLoadingStats,
    tableData,
    totalCount,
    currentPage,
    pageSize,
    statsData
} from "../@signals"


export default function useRetailerProducts() {
    const { showToast } = useAppToast()

    const fetchProducts = () => {
        isLoadingTable.value = true

        const payload = {
            ...tableFiltersValue.value,
            page: currentPage.value,
            pageSize: pageSize.value
        }

        postSubmit(`${BACKEND_APIS.RETAILER_PRODUCTS}/search`, payload)
            .then(res => {
                if (res) {
                    tableData.value = res.data || []
                    totalCount.value = res.total || 0
                }
            })
            .catch(() => showToast.error('Error loading retailer products'))
            .finally(() => {
                isLoadingTable.value = false
                isLoadingFilters.value = false
            })
    }

    const fetchStats = () => {
        isLoadingStats.value = true

        postSubmit(`${BACKEND_APIS.RETAILER_PRODUCTS}/stats`, filtersValue.value)
            .then(res => {
                if (res) {
                    statsData.value = res
                }
            })
            .catch(() => console.error('Error loading stats'))
            .finally(() => {
                isLoadingStats.value = false
            })
    }

    // Trigger search when filters are submitted
    useEffect(() => {
        if (isLoadingFilters.value) {
            fetchProducts()
            fetchStats()
        }
    }, [isLoadingFilters.value])

    // Refetch when page or pageSize changes
    useEffect(() => {
        if (totalCount.value > 0) {
            fetchProducts()
        }
    }, [currentPage.value, pageSize.value])



    return {
        isLoading: isLoadingTable.value,
        data: tableData.value,
        total: totalCount.value,
        refetch: fetchProducts
    }
}
